module.exports = __webpack_public_path__ + "static/img/icon-mall-player.317a4a60.png";